//React
import React, { useEffect, useState, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import JSZip from 'jszip';
import fileDownload from 'file-saver';
import ImageViewer from 'react-simple-image-viewer';
//API
import { GcodeApi } from '../../apis/index';
//Material-UI
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
//Components
import MyLoading from '../../components/Loading.js';

const useStyles = makeStyles({
  root: {
    textTransform: 'none',
  },

  border: {
    background: 'rgb(63, 89, 140)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 0px 30px 30px rgba(0, 0, 0, 0)',
    color: '#FFFFFF',
    width: '100%',
    padding: '15px 30px',
    fontSize: '1.2rem',
  },

  divspace: {
    padding: '30px',
  },

  spacingTop: {
    marginTop: '25px',
    padding: '5px 15px',
    border: '2px solid',
  },

  infoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    background: '#D9D9D9',
    height: '28px',
    width: '110px',
    margin: '5px 5px',
  },
  boxcard: {
    paddingTop: '30px',
    width: '100%',
  },

  media: {
    height: 500,
  },
  formControl: {
    minWidth: 120,
  },
});

const GcodeUpdate = (props) => {
  const classes = useStyles();
  const id = props.match.params.id;

  const [gcodeGroup, setGcodeGroup] = useState({});
  const [patients, setPatients] = useState({});
  const [diagnosis, setDiagnosis] = useState({});
  const [pictures, setPictures] = useState([]);
  const [hospital, setHospital] = useState({});
  const [wound, setWound] = useState({});
  const [member, setMember] = useState({});
  const [gcode, setGcode] = useState([]);
  const [gcodeData, setGcodeData] = useState([]);
  const [images, setImages] = useState([]);
  const [drawimages, setDrawImages] = useState([]);
  const [imageBlobUrls, setImageBlobUrls] = useState([]);
  const [drawImageBlobUrls, setDrawImageBlobUrls] = useState([]);
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isDrawViewerOpen, setIsDrawViewerOpen] = useState(false);
  const [isViewerbutton, setIsViewerbutton] = useState(false);
  const [cancelBackground, setCancelBackground] = useState(false);
  const [rInfo, setRinfo] = useState({});
  const [stls, setStls] = useState([]);
  const [bestStl, setBestStl] = useState({});

  const [loading, setLoading] = useState(false);

  // path에서 rokithc.com 이후의 경로만 추출
  const extractPathFromUrl = (url) => {
    if (!url) return '';
    const parts = url.split('rokithc.com');
    if (parts.length > 1) {
      const path = parts[parts.length - 1];
      // 앞의 '/' 제거
      return path.startsWith('/') ? path.substring(1) : path;
    }
    return url;
  };

  const getGcodeDetail = async (id) => {
    const res = await GcodeApi.getGcodeDetail(id);
    setGcodeGroup(res.data.gcodegroup);
    setDiagnosis(res.data.diagnosis);
    if (res.data.diagnosis.patient != null) {
      setPatients(res.data.diagnosis.patient);
      setHospital(res.data.diagnosis.patient.hospital);
      setMember(res.data.diagnosis.patient.member);
    } else {
      alert(
        '해당 환자는 관리자에 의해 삭제되었습니다. \n해당환자에 대해 REGEN 발급을 진행하여도 사용자가 확인할 수 없습니다.',
      );
    }

    setPictures(res.data.picture);
    setWound(res.data.wound);
    setGcodeData(res.data.gcodegroup.gcodes);
    setRinfo(res.data.rInfo);

    // 이미지를 auth API로 로드하여 blob URL로 변환
    const loadImages = async () => {
      const imagePromises = res.data.picture.map(async (picture) => {
        try {
          const path = extractPathFromUrl(picture.imgUrl);
          const blob = await GcodeApi.getWoundPicture(path);
          return URL.createObjectURL(blob);
        } catch (error) {
          console.error('Failed to load image:', error);
          return null;
        }
      });
      const imageUrls = await Promise.all(imagePromises);
      setImageBlobUrls(imageUrls);
      setImages(imageUrls.filter(url => url !== null));

      const drawImagePromises = res.data.picture.map(async (picture) => {
        try {
          const path = extractPathFromUrl(picture.drawImgUrl);
          const blob = await GcodeApi.getWoundPicture(path);
          return URL.createObjectURL(blob);
        } catch (error) {
          console.error('Failed to load draw image:', error);
          return null;
        }
      });
      const drawImageUrls = await Promise.all(drawImagePromises);
      setDrawImageBlobUrls(drawImageUrls);
      setDrawImages(drawImageUrls.filter(url => url !== null));
    };

    loadImages();

    if (res.data.gcodegroup.gcodes.length !== 0) {
      setIsViewerbutton(true);
    }
  };

  const getSTLDetail = async (id) => {
    const res = await GcodeApi.getSTLDetail(id);
    setStls(res.data);

    res.data.map((stlList, i) => {
      if (stlList.bestYn === true) {
        setBestStl(res.data[i]);
      }
    });
  };
  useEffect(() => {
    getGcodeDetail(id);
    getSTLDetail(id);
  }, []);

  // 컴포넌트 언마운트 시 blob URL 정리
  useEffect(() => {
    return () => {
      imageBlobUrls.forEach(url => {
        if (url) URL.revokeObjectURL(url);
      });
      drawImageBlobUrls.forEach(url => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, [imageBlobUrls, drawImageBlobUrls]);

  useEffect(() => {
    if (gcodeGroup.gcodeGroupStatus === 'Cancel') {
      alert('취소된 요청입니다. 그래도 하시겠습니까?');
      setCancelBackground(true);
    }
  }, [gcodeGroup]);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const openDrawImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsDrawViewerOpen(true);
  }, []);

  const closeDrawImageViewer = () => {
    setCurrentImage(0);
    setIsDrawViewerOpen(false);
  };

  const handleDownloadFile = async (fileUrl, filename) => {
    try {
      setLoading(true);
      const path = extractPathFromUrl(fileUrl);
      const blob = await GcodeApi.getWoundPicture(path);
      fileDownload(blob, filename);
    } catch (error) {
      console.error('Failed to download file:', error);
      alert('파일 다운로드에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleImageDownloadrInfo = async () => {
    if (!rInfo) {
      alert('해당 병원에 등록된 kit가 없는 request 입니다.');
      return null;
    }

    const zip = new JSZip();

    const promises = pictures.map(async (picture, i) => {
      try {
        const path = extractPathFromUrl(picture.imgUrl);
        const blob = await GcodeApi.getWoundPicture(path);
        const filename = picture.imgUrl.split('/').pop();
        zip.file(filename, blob, { binary: true });

        if (picture.drawYn) {
          const drawPath = extractPathFromUrl(picture.drawImgUrl);
          const drawBlob = await GcodeApi.getWoundPicture(drawPath);
          const drawFilename = picture.drawImgUrl.split('/').pop();
          zip.file(drawFilename, drawBlob, { binary: true });
        }

        if (i === pictures.length - 1) {
          const hinfoFilename = 'h.info';
          const hinfo = numberPad(patients.id, 19);
          zip.file(hinfoFilename, hinfo, { binary: false });

          const rInfoFilename = 'r.info';
          let rInfoStr = '';
          for (const [key, value] of Object.entries(rInfo)) {
            if (key === 'kit') {
              for (const [kitKey, kitValue] of Object.entries(value)) {
                if (kitKey !== 'hospital' && kitKey !== 'woundType') {
                  rInfoStr += `${kitKey}=${kitValue}\n`;
                }
              }
            } else {
              rInfoStr += `${key}=${value}\n`;
            }
          }
          zip.file(rInfoFilename, rInfoStr, { binary: false });
        }
      } catch (error) {
        console.error(`Failed to process picture at index ${i}:`, error);
      }
    });

    await Promise.all(promises);

    const content = await zip.generateAsync({ type: 'blob' });
    fileDownload(content, `${gcodeGroup.id}.zip`);
  };

  function numberPad(n, width) {
    n = n + '';
    return n.length >= width
      ? n
      : new Array(width - n.length + 1).join('0') + n;
  }

  const uploadGcode = async () => {
    const formData = new FormData();
    if (gcode.length === 0) {
      alert('Please upload the file first.');
      return;
    }
    for (let i = 0; i < gcode.length; i++) {
      if (gcode[i].name.split('.').reverse()[0] !== 'regen') {
        alert('Only the .regen extension can be uploaded.');
        setGcode([]);
        return;
      } else {
        formData.append('files', gcode[i]);
      }
    }
    setLoading(true);
    const res = await GcodeApi.uploadGcode(id, formData);
    if (res !== null && res.statusCode === 200) {
      alert('Gcode Upload Success');
      props.history.go(0);
    } else {
      alert('Gcode Upload Fail');
    }
    setLoading(false);
  };

  const issuedGcode = async () => {
    setLoading(true);
    const res = await GcodeApi.issuedGcode(id, null);
    if (res !== null && res.statusCode === 200) {
      // props.history.go(-1);
      props.history.push('/regen');
    } else {
      setLoading(false);
      alert(res.statusCode + '\n' + res.message);
    }
  };

  const onDrop = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    const { files } = event.dataTransfer;
    if (files && files.length > 0) {
      const filesArray = Array.from(files);
      setGcode((prevFiles) => [...prevFiles, ...filesArray]);
    }
  }, []);

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const setDate = (utcDate) => {
    const date = new Date(utcDate);
    date.setHours(date.getHours() + 9);
    return date.toISOString().replace('T', ' ').substring(0, 19);
  };

  return (
    <>
      <div className={classes.root}>
        <Grid container direction="row" alignItems="center">
          <div
            style={{
              fontWeight: '700',
              fontSize: '30px',
              color: '#495057',
              marginBottom: '20px',
            }}
          >
            REGEN FILE INFORMATION
          </div>
        </Grid>
        <div className={classes.border}>Info</div>
        <div style={{ padding: '30px 0px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              borderRadius: '5px',
              padding: '0px',
            }}
          >
            <div style={{ width: '120px' }}>
              <Form.Label>Country Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Hospital Name"
                name="name"
                value={hospital.countryCode}
                disabled
              />
            </div>
            <div style={{ width: '320px' }}>
              <Form.Label>Hospital Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Hospital Name"
                name="name"
                value={hospital.name}
                disabled
              />
            </div>
            <div style={{ width: '190px' }}>
              <Form.Label>Patient Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Patient Code"
                name="name"
                value={patients.code}
                disabled
              />
            </div>
            <div style={{ width: '130px' }}>
              <Form.Label>Wound Type</Form.Label>
              <Form.Control
                type="text"
                placeholder="Wound Type"
                name="name"
                value={wound.type}
                disabled
              />
            </div>
            <div style={{ width: '140px' }}>
              <Form.Label>Status</Form.Label>
              <Form.Control
                type="text"
                placeholder="Status"
                name="name"
                value={gcodeGroup.gcodeGroupStatus}
                disabled
              />
            </div>
            <Grid style={{ width: '120px' }}>
              <Form.Label>Gcode Group ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="ID"
                name="name"
                value={gcodeGroup.id}
                disabled
              />
            </Grid>
          </div>
          <div style={{ marginTop: '15px' }}>
            <Form.Label>Reject Reason</Form.Label>
            <Form.Control
              type="text"
              placeholder="Reject Reason"
              name="name"
              value={
                gcodeGroup.rejectReason ? gcodeGroup.rejectReason : '정상 발급'
              }
              disabled
            />
          </div>
        </div>
        <Grid>
          <Box className={classes.border}>Image, STL Quality Info</Box>
          <div style={{ display: 'flex', margin: '5px 0px' }}>
            <div
              style={{
                border: '1px solid #D9D9D9',
                width: '100%',
                borderRadius: '10px',
                marginRight: '5px ',
              }}
            >
              <div style={{ display: 'flex', padding: '20px' }}>
                <div
                  style={{
                    width: '100%',
                  }}
                >
                  {pictures.map((picture, index) => (
                    <Grid key={index}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={imageBlobUrls[index] || ''}
                          onClick={() => openImageViewer(index)}
                          width="100"
                          style={{
                            height: '100%',
                            width: '95%',
                            objectFit: 'cover',
                          }}
                          alt=""
                        />
                      </div>
                    </Grid>
                  ))}
                  {isViewerOpen && (
                    <ImageViewer
                      src={images}
                      currentIndex={currentImage}
                      onClose={closeImageViewer}
                      backgroundStyle={{
                        backgroundColor: 'rgba(0,0,0,0.9)',
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    width: '100%',
                  }}
                >
                  {pictures.map((picture, index) => (
                    <Grid key={index}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={drawImageBlobUrls[index] || ''}
                          onClick={() => openDrawImageViewer(index)}
                          width="100"
                          style={{
                            height: '100%',
                            width: '95%',
                            objectFit: 'cover',
                          }}
                          alt=""
                        />
                      </div>
                    </Grid>
                  ))}

                  {isDrawViewerOpen && (
                    <ImageViewer
                      src={drawimages}
                      currentIndex={currentImage}
                      onClose={closeDrawImageViewer}
                      backgroundStyle={{
                        backgroundColor: 'rgba(0,0,0,0.9)',
                      }}
                    />
                  )}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '20px',
                }}
              >
                <Grid>
                  <button
                    className={classes.root}
                    onClick={handleImageDownloadrInfo}
                    color="primary"
                    style={{
                      display: 'flex',
                      padding: '8px 20px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px',
                      border: '2px solid #3F51B5',
                      background: '#FFF',
                      fontSize: '14px',
                      fontWeight: '600',
                    }}
                    sx={{ textTransform: 'none' }}
                  >
                    <SaveAltIcon style={{ marginRight: '5px' }} />
                    Download Image
                  </button>
                </Grid>
              </div>
            </div>
            <div
              style={{
                border: '1px solid #D9D9D9',
                width: '100%',
                marginLeft: '5px',
                borderRadius: '10px',
                padding: '20px',
              }}
            >
              <div style={{ fontSize: '19px' }}>
                <div style={{ marginBottom: '16px' }}>
                  ID : {stls[0] ? stls[0].id : ''}
                </div>
                <div>
                  Best STL Y/N : {stls[0] ? stls[0].bestYn.toString() : ''}
                </div>
                <div>Threshold : {stls[0] ? stls[0].threshold : ''}</div>
                <div>
                  Volume :{' '}
                  {stls[0] ? parseFloat(stls[0].volume).toFixed(2) : ''}
                </div>
                <div>
                  Quality Score :{' '}
                  {stls[0] ? parseFloat(stls[0].qualityScore).toFixed(2) : ''}
                </div>
                <div>
                  Quality Score Flag : {stls[0] ? stls[0].qualityScoreFlag : ''}
                </div>
                <div>Error : {stls[0] ? stls[0].stlError : ''}</div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '125px',
                }}
              >
                <button
                  className={classes.root}
                  onClick={() => {
                    if (stls[0] && stls[0].stlUrl) {
                      const filename = stls[0].stlUrl.split('/').pop();
                      handleDownloadFile(stls[0].stlUrl, filename);
                    }
                  }}
                  color="primary"
                  style={{
                    color: '#3F51B5',
                    display: 'flex',
                    padding: '8px 20px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '10px',
                    border: '2px solid #3F51B5',
                    background: '#FFF',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                  disabled={!stls[0] || !stls[0].stlUrl}
                >
                  <SaveAltIcon style={{ marginRight: '5px' }} />
                  Download STL
                </button>
              </div>
            </div>
          </div>
        </Grid>
        <Grid>
          <Box className={classes.border}>GCODE Upload</Box>
          <div>
            <div
              onDrop={onDrop}
              onDragOver={onDragOver}
              style={{
                border: '2px dashed #D9D9D9',
                borderRadius: '10px',
                padding: '30px',
                width: '100%',
                height: '222px',
                margin: '20px auto',
                textAlign: 'center',
                color: '#495057',
              }}
            >
              <div style={{ display: gcode.length === 0 ? 'block' : 'none' }}>
                <div
                  style={{
                    fontSize: '19px',
                    fontWeight: '600',
                    marginBottom: '10px',
                  }}
                >
                  Upload Regen File
                </div>
                <CloudUploadOutlinedIcon
                  style={{ fontSize: '60px', color: '#495057' }}
                />
              </div>
              <div>
                {gcode.map((file) => (
                  <div>{file.name}</div>
                ))}
              </div>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <button
                  color="primary"
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    textTransform: 'none',
                    borderRadius: '10px',
                  }}
                  onClick={uploadGcode}
                  className={classes.spacingTop}
                >
                  <FileUploadOutlinedIcon style={{ marginRight: '10px' }} />
                  Upload Regen File
                </button>
              </Grid>
            </div>
          </div>
        </Grid>
        <Box className={classes.border}>Regen Info</Box>
        {gcodeData.map((gcode, index) => (
          <div>
            <div
              style={{
                padding: '25px 30px',
                border: '2px solid #D9D9D9',
                borderRadius: '10px',
                background: '#FFF',

                margin: '15px 0px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ width: '350px' }}>
                  <div
                    style={{
                      color: '#495057',
                      fontSize: 20,
                      fontFamily: 'Pretendard Variable',
                      fontWeight: '600',
                      wordWrap: 'break-word',
                    }}
                  >
                    Patch Info
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div>
                      <div>Thickness (mm)</div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '5px',
                          background: '#D9D9D9',
                          height: '28px',
                        }}
                      >
                        {gcode.depth}
                      </div>
                    </div>
                    <div>
                      <div>
                        Area (mm<sup>2</sup>)
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '5px',
                          background: '#D9D9D9',
                          height: '28px',
                        }}
                      >
                        {gcode.area}
                      </div>
                    </div>
                    <div>
                      <div>Volume (ml)</div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '5px',
                          background: '#D9D9D9',
                          height: '28px',
                        }}
                      >
                        {gcode.volume}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ width: '1px', background: '#D9D9D9' }}></div>
                <div
                  style={{
                    width: '60%',
                  }}
                >
                  <div
                    style={{
                      color: '#495057',
                      fontSize: 20,
                      fontFamily: 'Pretendard Variable',
                      fontWeight: '600',
                      wordWrap: 'break-word',
                    }}
                  >
                    Prtinting Info
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div style={{ display: 'flex', width: '370px' }}>
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div>
                          <div
                            style={{
                              display: 'flex',
                            }}
                          >
                            <div
                              className={classes.infoBox}
                              style={{ background: '#FFF', width: '80px' }}
                            ></div>
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                alignItems: 'flex-end',
                              }}
                            >
                              Bioink1
                            </div>
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                alignItems: 'flex-end',
                              }}
                            >
                              Bioink2
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                            }}
                          >
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                justifyContent: 'flex-end',
                                width: '80px',
                              }}
                            >
                              Time (min)
                            </div>
                            <div className={classes.infoBox}>
                              {gcode.bioink1Min}
                            </div>
                            <div className={classes.infoBox}>
                              {gcode.bioink2Min}
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                            }}
                          >
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                justifyContent: 'flex-end',
                                width: '80px',
                              }}
                            >
                              Volume (ml)
                            </div>
                            <div className={classes.infoBox}>
                              {gcode.bioink1Ml}
                            </div>
                            <div className={classes.infoBox}>
                              {gcode.bioink2Ml}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', width: '240px' }}>
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                justifyContent: 'flex-start',
                                width: '90px',
                              }}
                            ></div>
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                alignItems: 'flex-end',
                              }}
                            >
                              Scaffold
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                justifyContent: 'flex-end',
                                width: '90px',
                              }}
                            >
                              Time (min)
                            </div>
                            <div className={classes.infoBox}>
                              {gcode.scaffoldMin}
                            </div>
                          </div>
                          <div style={{ display: 'flex' }}>
                            <div
                              className={classes.infoBox}
                              style={{
                                background: '#FFF',
                                justifyContent: 'flex-end',
                                width: '90px',
                              }}
                            >
                              Length (mm)
                            </div>
                            <div className={classes.infoBox}>
                              {gcode.scaffoldMm}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '20px',
                }}
              >
                <div>
                  <button
                    className={classes.root}
                    onClick={() => {
                      if (gcode.gcodeUrl) {
                        const filename = gcode.gcodeUrl.split('/').pop();
                        handleDownloadFile(gcode.gcodeUrl, filename);
                      }
                    }}
                    color="primary"
                    style={{
                      color: '#3F51B5',
                      display: 'flex',
                      padding: '8px 20px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px',
                      border: '2px solid #3F51B5',
                      background: '#FFF',
                      fontSize: '14px',
                      fontWeight: '600',
                      marginRight: '5px',
                      cursor: 'pointer',
                    }}
                    disabled={!gcode.gcodeUrl}
                  >
                    <SaveAltIcon style={{ marginRight: '5px' }} />
                    Download Regen File
                  </button>
                </div>
                <div>
                  <button
                    className={classes.root}
                    onClick={async (e) => {
                      setLoading(true);
                      const res = await GcodeApi.deleteRegenFile(gcode.id);
                      if (res) {
                        props.history.go(0);
                      } else {
                        alert(res.statusCode + '\n' + res.message);
                      }
                      setLoading(false);
                    }}
                    color="secondary"
                    style={{
                      display: 'flex',
                      padding: '8px 20px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px',
                      border: '2px solid red',
                      background: '#FFF',
                      fontSize: '14px',
                      fontWeight: '600',
                      marginLeft: '5px',
                    }}
                    sx={{ textTransform: 'none' }}
                  >
                    <DeleteOutlineIcon />
                    Delete Regen File
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {gcodeGroup.insertDate && (
                <div>{setDate(gcodeGroup.insertDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {gcodeGroup.insertId}
            </div>
          </Form.Group>
        </div>
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {gcodeGroup.insertDate && (
                <div>{setDate(gcodeGroup.modifyDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {gcodeGroup.modifyId}
            </div>
          </Form.Group>
        </div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <button className="blue" onClick={issuedGcode}>
            UPDATE
          </button>
        </Grid>
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </>
  );
};

export default GcodeUpdate;
